/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import custom components
import { collapseNavigationSidebar } from '../../../legacy/store/appReducer';
import AnnotationRecordingInfo from './container/AnnotationRecordingInfo';
import AllLeadView from './container/AllLeadView';
import AnnotatorView from './container/AnnotatorView';
import { init } from './state';
import { fetchCCTAnotator, fetchBaseRhythmDropdown } from '../../../legacy/containers/ApiUrls';
import styles from './Annotator.css';
import EventHighlightView from './container/EventHighlightView/EventHighlightView';
import EcgLoader from 'legacy/containers/EcgLoader';
import DrawerPanel from '../../components/Common/DrawerPanel';
import CCTPatientHistory from '../../components/CCTPatientHistory'

// import constants / utils
import { DRAWER_ANCHOR } from '../../components/Common/DrawerPanel/Constants'

// import SVGs
import PolygonBeat from 'static/images/icons/PolygonBeat.svg';
import EllipseBeat from 'static/images/icons/EllipseBeat.svg';
import RectangleNoiseBeat from 'static/images/icons/RectangleNoiseBeat.svg';


// Constants to be used in class 
// ========== ========== ========== ========== ========== ========== ========== ==========
const TABS = ['rhythm', 'eventHighlight'];

const SIDE_DRAWERS = {
    PATIENTS_HISTORY: 'Patient History',
    MDN_PROTOCOL: 'Mdn Protocol'
};
// basic modal style for Drawer
const BASIC_MODAL_WINDOW_STYLE = {
    borderTop: 'solid 1px #1f3568',
    borderBottom: 'solid 1px #1f3568',
    borderRight: 'solid 1px #1f3568',
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
}

const DRAWER_WINDOW_STYLE_MDN_PROTOCOL = {
    top: 45,
    width: 520,
    height: 680,
    ...BASIC_MODAL_WINDOW_STYLE
}

const DRAWER_WINDOW_STYLE_PATIENT_HISTORY = {
    top: 245,
    // width: 1040,
    width: 1320,
    height: 680,
    ...BASIC_MODAL_WINDOW_STYLE
}
// Sidebar width css
// @value sidebarWidth 220px;
// @value sidebarCollapsedWidth 60px;
// ========== ========== ========== ========== ========== ========== ========== ==========

const Annotator = props => {
    const dispatch = useDispatch();
    const me = useSelector(state => state.app.dataSources.me);
    const { sidebarIsCollapsed } = useSelector(state => state.app);
    const Annotator = useSelector(state => state.annotator);
    const SelectedLead = Annotator.selectedLead;
    const [SelectedTab, setSelectedTab] = useState('rhythm');
    const [sideDrawerState, setSideDrawerState] = useState({
        type: SIDE_DRAWERS.PATIENTS_HISTORY,
        active: false,
        bannerTopMargin: 0 // banner Top-Position
    });

    const isTabActive = tab => {
        return SelectedTab === tab ? styles.tabActive : styles.tab;
    };

    const changeTab = (e, tab) => {
        e.preventDefault();
        if (SelectedTab != tab) {
            setSelectedTab(tab);
        }
    };

    // handle Drawer selection
    const selectDrawer = type => {
        switch (type) {
            case SIDE_DRAWERS.MDN_PROTOCOL:
                setSideDrawerState({
                    type: SIDE_DRAWERS.MDN_PROTOCOL,
                    active: true,
                    bannerTopMargin: 520
                })
                break;
            case SIDE_DRAWERS.PATIENTS_HISTORY:
                setSideDrawerState({
                    type: SIDE_DRAWERS.PATIENTS_HISTORY,
                    active: true,
                    bannerTopMargin: 724
                })
                break;
            default:
                break;
        }
    }

    // get the style object, each object is for specific Drawer Modal-window
    const getDrawerContainerStyle = drawer => {
        switch (drawer.type) {
            case SIDE_DRAWERS.MDN_PROTOCOL:
                return DRAWER_WINDOW_STYLE_MDN_PROTOCOL
                break;
            case SIDE_DRAWERS.PATIENTS_HISTORY:
                return DRAWER_WINDOW_STYLE_PATIENT_HISTORY
                break;
            default:
                break;
        }
    }

    // get the Container / Component based on drawer selection
    const getDrawerComponent = drawer => {
        switch (drawer.type) {
            case SIDE_DRAWERS.MDN_PROTOCOL:
                return <div>MDN_PROTOCOL component</div>
                break;
            case SIDE_DRAWERS.PATIENTS_HISTORY:
                return <CCTPatientHistory  handleDrawerClose={() => { handleDrawerClose() }} match = {props.match}/>
                break;
            default:
                break;
        }
    }

    // Outside / On close - set active state to false
    const handleDrawerClose = () => {
        let drawerStateTemp = sideDrawerState;
        drawerStateTemp.active = false;
        setSideDrawerState({ ...drawerStateTemp })
    }


    //  UseEffect
    useEffect(() => {
        dispatch(init(props.match.params.recordingId))
        dispatch(fetchCCTAnotator(props.match.params.recordingId))
        dispatch(fetchBaseRhythmDropdown())
        dispatch(collapseNavigationSidebar())
    }, [])

    useEffect(() => {
        dispatch(init(props.match.params.recordingId))
        dispatch(fetchCCTAnotator(props.match.params.recordingId))
        dispatch(fetchBaseRhythmDropdown())
        dispatch(collapseNavigationSidebar())
        setSideDrawerState({
            type: SIDE_DRAWERS.PATIENTS_HISTORY,
            active: false,
            bannerTopMargin: 0
        })
    }, [props.match.params.recordingId])
    
    return (
        <div className={styles.AnnotatorContainer}>
            {Annotator.recordingInfo.isfetching ? (
                <div className={styles.AnnotatorContainerLoading}>
                    <EcgLoader />
                    {/* <CircularProgress size={100} /> */}
                </div>
            ) : (
                <React.Fragment>
                    {/* Left bar */}
                    <div className={styles.AnnotatorLeftBar}>
                        <AnnotationRecordingInfo 
                            urlParams={props.match.params}
                        />
                    </div>
                    {/* Right Bar */}
                    <div className={styles.AnnotatorRightBar}>
                        <div className={styles.headerTab}>
                            <div style={{ display: 'flex' }}>
                                <div className={styles.tabs}>
                                    <div
                                        className={isTabActive(TABS[0])}
                                        onClick={e => changeTab(e, TABS[0])}
                                    >
                                        Rhythms
                                    </div>
                                    <div
                                        className={isTabActive(TABS[1])}
                                        onClick={e => changeTab(e, TABS[1])}
                                    >
                                        Event Highlight
                                    </div>
                                </div>
                                {SelectedTab === 'rhythm' && (
                                    <div className={styles.lagendsInfo}>
                                        Hold down control or right-click to change beat
                                        <div className={styles.beats} style={{display:"flex"}}>
                                            Ve  &nbsp; <PolygonBeat /> &nbsp; &nbsp;  &nbsp; Beat  &nbsp; <EllipseBeat />{' '}
                                            &nbsp; &nbsp;  &nbsp; SVe  &nbsp; <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M0 10L10 0L20 10L10 20L0 10Z" fill="#5EC2FB"/></g></svg>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <hr className={styles.tabLine} />
                        </div>
                        {SelectedTab === TABS[0] && (
                            <React.Fragment>
                                {SelectedLead === null ? <AllLeadView /> : <AnnotatorView />}
                            </React.Fragment>
                        )}
                        {SelectedTab === TABS[1] && (
                            <React.Fragment>
                                <EventHighlightView />
                            </React.Fragment>
                        )}
                    </div>
                    <div className={styles.drawer}>
                        {/* MDN Protocol is not in scope yet, will be commenting out this section */}
                        {/* <div className={styles.mdnProtocolDrawerBanner}
                            style={{ left: sidebarIsCollapsed ? '60px' : '220px' }}
                            onClick={() => { selectDrawer(SIDE_DRAWERS.MDN_PROTOCOL) }}>
                            <strong>{SIDE_DRAWERS.MDN_PROTOCOL}</strong>
                        </div> */}
                        <div className={styles.patientHistoryDrawerBanner}
                            style={{ left: sidebarIsCollapsed ? '60px' : '220px' }}
                            onClick={() => { selectDrawer(SIDE_DRAWERS.PATIENTS_HISTORY) }}>
                            <strong>{SIDE_DRAWERS.PATIENTS_HISTORY}</strong>
                        </div>
                        {sideDrawerState.active &&
                            <DrawerPanel
                                anchor={DRAWER_ANCHOR.LEFT}
                                anchorToSidebar={true}
                                active={sideDrawerState.active}
                                childComponent={getDrawerComponent(sideDrawerState)}
                                handleDrawerClose={() => { handleDrawerClose() }}
                                windowStyle={getDrawerContainerStyle(sideDrawerState)}
                                banner={true}
                                bannerText={sideDrawerState.type}
                                bannerTopMargin={sideDrawerState.bannerTopMargin}
                            />
                        }

                    </div>
                </React.Fragment>
            )
            }
        </div >
    );
};

export default Annotator;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/Annotator.jsx